import { createFileRoute, Outlet } from "@tanstack/react-router";
import { dehydrate, HydrationBoundary } from "@tanstack/react-query";

export const Route = createFileRoute("/_dashboard/emails/system")({
  component: SystemEmailsComponent,
  loader: async ({ context }) => {
    return {
      crumb: "System emails",
      dehydratedState: dehydrate(context.queryClient),
    };
  },
});

function SystemEmailsComponent() {
  const { dehydratedState } = Route.useLoaderData();

  return (
    <HydrationBoundary state={dehydratedState}>
      <Outlet />
    </HydrationBoundary>
  );
}
